import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const WestHamHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("West Ham"));
        
        const fav = {
            teamName: "West Ham",
            teamLogo: PLsoccerLogos["West Ham"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

            const data = await response.json();
        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
            const fetchFavorites = async () => {
                try {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=West Ham`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                        credentials: "include",
                    });
        
                    if (!res.ok) {
                        console.log("No favorites found or error fetching");
                        setFavoritesLoaded(true);
                        return;
                    }
                    const data = await res.json();
        
                    // highlight team star
                    setIsTeamFavorite(data.team?.isFavorite || false);
        
                    // highlight player stars
                    const playerKeys = data.players
                        .filter(p => p.isFavorite && p.name.startsWith("West Ham"))
                        .map(p => p.name);  
                    setStarredPlayers(playerKeys);
                    setFavoritesLoaded(true);
    
                } catch (err) {
                    console.error("Error fetching favorites", err);
                }
            };
        
            fetchFavorites();
        }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["West Ham United"]}
                        alt="West Ham United"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>West Ham United</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="West Ham United" /></p>
                        <p><span className="soccer-label">Stadium:</span> The London Stadium</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Nuno Espirito Santo</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Paco Jémez, Mark Robson, Steve Potts, Gerard Prenderville</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="West Ham United"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="West Ham United" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="West Ham United" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Known as the “The Academy of Football” for producing generational English talents</p>
                        <br />
                        <p>• Three West Ham players played crucial roles in England winning the 1966 World Cup</p>
                        <br />
                        <p>• West Ham player, Geoff Hurst, scored a hat trick in the World Cup final in 1966</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default WestHamHome;